import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { CustomersService } from '../../_services/customers.service';
import { ConstantsService } from '../../_services/constants.service';
import { CustomService } from '../../_services/custom.service';
import { DataService, UserService, CustomerService, AuthenticationService, StorageService } from '../../_services/index';
import { InvestmentService, LoansService, OptionsserviceService } from '../../_services/index';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';

@Component({
  selector: 'app-allcustomers',
  templateUrl: './allcustomers.component.html',
  styleUrls: ['./allcustomers.component.css']
})
export class AllcustomersComponent implements OnInit {
  searchTerm='';
  start: number = 0;
  loading = false;
  view = 'main';
  count = '0';
  openedTab: any; // Currently opened preview tab
  public statuses = [
    { value: '0', display: 'All' },
    { value: '2', display: 'USSD' },
    { value: '1', display: 'Mobile' },
    { value: '3', display: 'Web' },
    { value: '4', display: 'Back Office' }
  ];
  magic_filter = {
    reset: false,
    account_officer: false,
    start: 0,
    token: '',
    registered_from: this.statuses[0].value,
    searchText: '',
    borrower: true,
    investor: true,
    loans: '',
    investments: '',
    ratings_one: false,
    ratings_two: false,
    ratings_three: false,
    ratings_four: false,
    ratings_five: false,
    customer_category:''
  };

  public marital_statuses = [
    // { value: '-2', display: 'All' },
    { value: '1', display: 'Single' },
    { value: '2', display: 'Married' },
    { value: '3', display: 'Divorced' },
    { value: '4', display: 'Widowed' },
  ];
  branches: any;
  products: any;
  states: any;
  action = 'normal'; // Search, Normal Request or Filter
  investor_box = true;
  borrower_box = true;
  ownershipCustomer: any;
  owningStaff: any;
  public durations = [
    { display: '0 - 1', checked: false, min: 0, max: 30 },
    { display: '0 - 3', checked: false, min: 31, max: 90 },
    { display: '4 - 6', checked: false, min: 91, max: 180 },
    { display: '7 - 12', checked: false, min: 181, max: 365 },
    { display: '1+ Years', checked: false, min: 366, max: 3650 }
  ];
  public adays = [
    { display: '1 - 3', checked: false, min: 0, max: 3 },
    { display: '4 - 10', checked: false, min: 4, max: 10 },
    { display: '> 10', checked: false, min: 10, max: 365 }
  ];

  public incomes = [
    { display: '< 50K', checked: false, min: 0, max: 50000 },
    { display: '51 - 100k', checked: false, min: 50001, max: 100000 },
    { display: '101k - 250k', checked: false, min: 100001, max: 250000 },
    { display: '250k - 500k', checked: false, min: 250001, max: 500000 },
    { display: '500k - 1m', checked: false, min: 500001, max: 1000000 },
    { display: '> 1m', checked: false, min: 1000001, max: 120000000 }
  ];
  public ages = [
    { display: '18 - 24', checked: false, min: 18, max: 24 },
    { display: '25 - 34', checked: false, min: 25, max: 34 },
    { display: '35 - 45', checked: false, min: 35, max: 45 },
    { display: 'above 45', checked: false, min: 46, max: 100 }
  ];
  public request_date = [
    { display: 'Today', checked: false, min: 0, max: 1 },
    { display: '2 - 7 days', checked: false, min: 2, max: 7 },
    { display: '2 - 4 weeks', checked: false, min: 8, max: 30 },
    { display: '1+ months', checked: false, min: 31, max: 100000 }
  ];
  currentUser: any;
  customers: any;
  verifier = { phone_verifier: false, email_verifier: false, bvn_verifier: false, PEOPLE_CUSTOMERS_ID: '' };
  enable_peer: any;
  sectors: any; 
  designations: any;
  occupations: any;
  overlayOpen: any;
  loan:any;
  constructor(public toastr: ToastrService, public authService: AuthenticationService, public optionsService: OptionsserviceService,
    public router: Router, public dataService: DataService, protected customersSrvc: CustomersService,
    protected constants: ConstantsService, public storageService: StorageService, public customService: CustomService) {
    //this.api_base = constants.read('api_base');
    this.currentUser = this.storageService.read<any>('currentUser');
    this.enable_peer = this.storageService.read<any>('enable_peer_to_peer');
    // this.DataService.reloadCustomers.subscribe(res => {
    //   this.normalLoad(this.navigation.next - 10);
    // })
    // this.enable_peer = this.storageService.read<any>('enable_peer_to_peer');
    // if (!authService.canViewModule('1,7,2,3,4,5,1026')) {
    //   this.router.navigate(['../unauthorized']);
    // }
    this.optionsService.getSec().subscribe(sectors => (this.sectors = sectors));
    this.optionsService.getOcc().subscribe(sectors => (this.occupations = sectors));
    this.optionsService.getDes().subscribe(sectors => (this.designations = sectors));
    this.dataService.customerDeleted.subscribe(res => { 
      this.loadCustomers();
    })
  }

  ngOnInit() {
    this.loadCustomers();
  }
  grantRight(right) {
    return this.authService.userHasRights(right);
  }
  open(page) {
    this.view = page;
  }
  searchLoad(test) {

    this.loadCustomers();
  }
  normalLoad(start) {
    // this.action = 'normal';
    // this.customersSrvc.getCustomersList(this.getCategory(), start, this.magic_filter, this.durations, this.sectors, this.occupations, this.currentUser).subscribe(data => {
    //   this.data = data;
    //   this.customers = data.all_cus.a;
    //   this.count = data.COUNT;

    //   if (this.customers[0] == undefined) {
    //     this.showEmptyState = true;
    //   } else {
    //     this.showEmptyState = false;
    //   }

    //   // Set the navigation params
    //   this.setNavigationParams(data);
    // });
  }
  checkLevel(sector, event, index) {
    this.durations[index]["checked"] = event;

  }
  loadCustomers() {
    this.loading = true;
    this.customService.getAllPlatformCustomers(this.currentUser.token, this.start, this.searchTerm)
      .subscribe(result => {
        this.loading = false;
        this.customers = result;
        this.count = result.count;
        this.start = parseInt(result.start);
      });
  }
  filterCustomers() {
    this.loading = true;
    this.customService.filterAllCustomers(this.currentUser.token, 0, this.searchTerm, this.magic_filter, this.ages, this.adays, this.marital_statuses, this.occupations, this.sectors, this.designations, this.incomes, this.branches, this.states  )
      .subscribe(result => {
        this.loading = false;
        this.customers = result;
        this.count = result.count;
        this.start = parseInt(result.start);
      });
  }
  getCustomerType(CUSTOMER_TYPE) {
    if (CUSTOMER_TYPE === '1') {
      return "individual";
    } else {
      return "corporate";
    }
  }
  showCustomerPreview(event, category, id) {

    event.preventDefault();

    // If the tab is open, then close it.
    if (this.openedTab == id) {
      this.openedTab = 0;
      return;
    } else {
      this.openedTab = id;
      return;
    }

  }
  takeOwnership(customer) {
    if (!this.grantRight('1')) {
      this.overlayOpen = 'no_right';
    } else {
      this.action = '1';
      this.ownershipCustomer = customer;
      this.owningStaff = this.currentUser;
      this.dataService.onTakeOwnership.emit(customer);
    }

  }
  changeOwnership(customer) {
    if (!this.grantRight('1')) {
      this.overlayOpen = 'no_right';
    } else {
      this.ownershipCustomer = customer;
      this.owningStaff = this.currentUser;
      this.dataService.onchangeOwnership.emit(customer);
    }
  }
  saveVerification(value, valid, PEOPLE_CUSTOMERS_ID) {

    this.loading = true;
    this.customersSrvc.saveVerification(value, this.currentUser.token, PEOPLE_CUSTOMERS_ID).subscribe(data => {
      this.loading = false;
      if (data.status == true) {
        this.showSuccess("Update successful");
      } else {
        this.showError("Error occured")
      }
    });
  }
  showSuccess(message) {
    this.toastr.success(message, 'Success!');
  }

  showError(message) {
    this.toastr.error(message, 'Error');
  }
  next() {
    this.start += 20;
    this.loadCustomers();
  }
  prev() {
    this.start = this.start - 20;
    this.loadCustomers();
  }
  sendEmailToCustomer(request) { 
    this.dataService.sendMailToCustomer.emit({ customer_id: request.PEOPLE_ID, is_multiple: false });
  }
  sendSMSToCustomer(request) { 
    this.dataService.sendSMSToCustomer.emit({ customer_id: request.PEOPLE_ID, is_multiple: false });
  }
  openLoan(request) { 
    this.customersSrvc.getCustomerDetails(1, request.PEOPLE_CUSTOMERS_ID, this.currentUser.token).subscribe(data => {
      this.loan = data.cust;
      this.dataService.loadHomeCustomerSideview.emit({ 'cust': data.cust });

    });
  }
}
